import type {GridCollection} from '@react-types/grid';
import type {Key} from 'react';
import type {KeyboardDelegate} from '@react-types/shared';
import type {GridState} from '../../@react-stately/grid';

interface GridMapShared {
  keyboardDelegate: KeyboardDelegate;
  actions: {
    onRowAction?: (key: Key) => void;
    onCellAction?: (key: Key) => void;
  };
}

// Used to share:
// keyboard delegate between useGrid and useGridCell
// onRowAction/onCellAction across hooks
export const gridMap = new WeakMap<
  GridState<unknown, GridCollection<unknown>>,
  GridMapShared
>();
